<template>
  <section
    class="faq-page"
    :class="{ loaded: pageLoaded }"
  >
    <div class="faq-container">

      <div class="faq-header">

        <span class="faq-label">
          Centro de Ayuda
        </span>

        <h1 class="faq-title">
          Preguntas Frecuentes
        </h1>

        <p class="faq-description">
          Resolvemos las dudas más comunes sobre nuestros servicios,
          procesos y formas de trabajo.
        </p>

      </div>

      <div class="faq-list">

        <article
          v-for="(faq, index) in faqs"
          :key="index"
          class="faq-item"
        >

          <button
            class="faq-question"
            type="button"
            @click="toggle(index)"
          >

            <span>
              {{ faq.question }}
            </span>

            <span
              class="faq-icon"
              :class="{ active: activeIndex === index }"
            >
              ↓
            </span>

          </button>

          <div
            class="faq-content"
            :class="{ active: activeIndex === index }"
          >

            <div class="faq-content-inner">

              <p>
                {{ faq.answer }}
              </p>

            </div>

          </div>

        </article>

      </div>

    </div>
  </section>
</template>

<script>
export default {
  name: "FaqComponent",

  data() {
    return {
      pageLoaded: false,
      activeIndex: 0,

      faqs: [
        {
          question: "¿Qué es Raptoris?",
          answer:
            "Raptoris es una empresa especializada en soluciones digitales para negocios, enfocada en organización digital, implementación de ventas digitales, presencia profesional en línea y soporte continuo."
        },
        {
          question: "¿Qué servicios ofrecen?",
          answer:
            "Ofrecemos gestión y organización digital, desarrollo web, implementación de canales de venta digitales, optimización de procesos, soporte técnico y mantenimiento continuo."
        },
        {
          question: "¿Qué es gestión y organización digital?",
          answer:
            "Consiste en digitalizar y optimizar procesos internos de tu negocio, como documentos, inventarios, bases de datos, automatizaciones y herramientas colaborativas."
        },
        {
          question: "¿Qué incluye la implementación de ventas digitales?",
          answer:
            "Diseñamos e implementamos canales de venta online como ecommerce, catálogos digitales, formularios de venta, integraciones de pago y automatización comercial."
        },
        {
          question: "¿Qué significa presencia profesional?",
          answer:
            "Creamos y mejoramos tu presencia digital mediante páginas web, branding, correo profesional, dominio empresarial y optimización de imagen online."
        },
        {
          question: "¿Ofrecen soporte después de terminar un proyecto?",
          answer:
            "Sí. Ofrecemos soporte técnico continuo, mantenimiento, actualizaciones y optimización para asegurar que tu negocio siga funcionando correctamente."
        },
        {
          question: "¿Trabajan con pequeñas empresas?",
          answer:
            "Sí, nos especializamos en apoyar emprendedores, startups y pequeñas y medianas empresas que buscan digitalizarse."
        },
        {
          question: "¿Pueden ayudarme si no tengo presencia digital?",
          answer:
            "Claro. Podemos ayudarte desde cero: dominio, hosting, página web, correo profesional y estrategia digital inicial."
        },
        {
          question: "¿Cuánto tiempo tarda un proyecto?",
          answer:
            "Depende del alcance. Algunos proyectos pueden completarse en pocos días, mientras que implementaciones más grandes pueden tomar varias semanas."
        },
        {
          question: "¿Cómo solicito una cotización?",
          answer:
            "Puedes contactarnos desde nuestra página de contacto y analizaremos tus necesidades para ofrecerte una propuesta personalizada."
        },
        {
          question: "¿Ofrecen planes mensuales?",
          answer:
            "Sí. Contamos con planes de soporte y optimización continua para negocios que necesitan acompañamiento constante."
        },
        {
          question: "¿Atienden de forma remota?",
          answer:
            "Sí. La mayoría de nuestros servicios pueden realizarse de forma remota, lo que nos permite atender clientes en cualquier ubicación."
        }
      ]
    };
  },

  mounted() {
    requestAnimationFrame(() => {
      this.pageLoaded = true;
    });
  },

  methods: {
    toggle(index) {
      this.activeIndex =
        this.activeIndex === index
          ? null
          : index;
    }
  }
};
</script>

<style scoped>

/* ===== PAGE ===== */

.faq-page {
  opacity: 0;
  transform: translateY(30px);

  transition:
    opacity .8s ease,
    transform .8s ease;

  background:
    linear-gradient(
      180deg,
      #f8fafc 0%,
      #ffffff 100%
    );
}

.faq-page.loaded {
  opacity: 1;
  transform: translateY(0);
}

/* ===== CONTAINER ===== */

.faq-container {
  max-width: 950px;
  margin: 0 auto;
  padding: 5rem 1.5rem;
}

/* ===== HEADER ===== */

.faq-header {
  text-align: center;
  margin-bottom: 4rem;
}

.faq-label {
  display: inline-block;

  padding: .45rem 1rem;
  margin-bottom: 1rem;

  border-radius: 999px;

  background: #ccfbf1;
  color: #0f766e;

  font-size: .85rem;
  font-weight: 700;
}

.faq-title {
  font-size: clamp(2.5rem, 6vw, 4rem);
  color: #012719;

  margin-bottom: 1rem;
}

.faq-description {
  max-width: 650px;
  margin: auto;

  line-height: 1.8;
  color: #64748b;
}

/* ===== LIST ===== */

.faq-list {
  display: flex;
  flex-direction: column;
}

/* ===== ITEM ===== */

.faq-item {
  border-bottom: 1px solid #e2e8f0;

  opacity: 0;
  transform: translateY(20px);
}

.loaded .faq-item {
  animation: fadeUp .7s ease forwards;
}

.loaded .faq-item:nth-child(1) { animation-delay: .05s; }
.loaded .faq-item:nth-child(2) { animation-delay: .10s; }
.loaded .faq-item:nth-child(3) { animation-delay: .15s; }
.loaded .faq-item:nth-child(4) { animation-delay: .20s; }
.loaded .faq-item:nth-child(5) { animation-delay: .25s; }
.loaded .faq-item:nth-child(6) { animation-delay: .30s; }
.loaded .faq-item:nth-child(7) { animation-delay: .35s; }
.loaded .faq-item:nth-child(8) { animation-delay: .40s; }
.loaded .faq-item:nth-child(9) { animation-delay: .45s; }
.loaded .faq-item:nth-child(10) { animation-delay: .50s; }
.loaded .faq-item:nth-child(11) { animation-delay: .55s; }
.loaded .faq-item:nth-child(12) { animation-delay: .60s; }

/* ===== QUESTION ===== */

.faq-question {
  width: 100%;

  display: flex;
  justify-content: space-between;
  align-items: center;

  gap: 1rem;

  border: none;
  background: transparent;

  cursor: pointer;

  padding: 1.75rem 0;

  text-align: left;

  font-size: 1.1rem;
  font-weight: 600;

  color: #012719;

  transition: color .25s ease;
}

.faq-question:hover {
  color: #0f766e;
}

/* ===== ICON ===== */

.faq-icon {
  flex-shrink: 0;

  font-size: 1.2rem;
  color: #0f766e;

  transition: transform .35s ease;
}

.faq-icon.active {
  transform: rotate(180deg);
}

/* ===== ANSWER ===== */

.faq-content {
  max-height: 0;

  overflow: hidden;

  opacity: 0;

  transition:
    max-height .45s ease,
    opacity .3s ease;
}

.faq-content.active {
  max-height: 300px;
  opacity: 1;
}

.faq-content-inner {
  padding-bottom: 1.5rem;
}

.faq-content p {
  margin: 0;

  line-height: 1.9;
  color: #475569;
}

/* ===== ANIMATION ===== */

@keyframes fadeUp {

  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }

}

/* ===== MOBILE ===== */

@media (max-width: 768px) {

  .faq-container {
    padding: 4rem 1rem;
  }

  .faq-question {
    font-size: 1rem;
    padding: 1.4rem 0;
  }

}

</style>